/**
 * --------------------------------------------------------------------------
 * helpers.js
 * Helper functions
 * --------------------------------------------------------------------------
 */

import { getUID } from 'bootstrap/js/src/util'

const ID_PREFIX = 'uoe-'

/**
 * Public methods
 */

const uoeUID = function () {
  return getUID(ID_PREFIX)
}

const escapeHtml = function (text) {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll('\'', '&#039;')
}

export { uoeUID, escapeHtml }
